export function directGatewayOrigin(configured: string | undefined, pageOrigin: string) {
  if (!configured) return pageOrigin
  const url = URL.parse(configured)
  if (
    !url ||
    url.protocol !== "https:" ||
    url.username ||
    url.password ||
    url.pathname !== "/" ||
    url.search ||
    url.hash
  )
    throw new Error("The cloud gateway must be a plain HTTPS origin.")
  return url.origin
}

export function directGatewayFetch(origin: string, fetcher: typeof fetch): typeof fetch {
  return ((resource, init) => {
    const url = new URL(resource instanceof Request ? resource.url : resource.toString(), origin)
    if (url.origin !== origin) return fetcher(resource, init)
    return fetcher(resource, { ...init, credentials: "include", mode: "cors", redirect: "error" })
  }) as typeof fetch
}
